export default () => {
  return {
    roleSuggestionList: [
      "CEO",
      "Communications",
      "Consulting",
      "Customer Service",
      "Education",
      "Engineering",
      "Finance",
      "Founder",
      "Health Professional",
      "HR",
      "IT",
      "Legal",
      "Marketing",
      "Operations",
      "Owner",
      "President",
      "Product",
      "Public Relations",
      "Real Estate",
      "Recruiting",
      "Research",
      "Sales"
    ],
    roleList: [{
      label: "CEO",
      value: "ceo",
      isSelected: false,
    },
    {
      label: "Communications",
      value: "communications",
      isSelected: false,
    },
    {
      label: "Consulting",
      value: "consulting",
      isSelected: false,
    },
    {
      label: "Customer Service",
      value: "customer_service",
      isSelected: false,
    },
    {
      label: "Education",
      value: "education",
      isSelected: false,
    },
    {
      label: "Engineering",
      value: "engineering",
      isSelected: false,
    },
    {
      label: "Finance",
      value: "finance",
      isSelected: false,
    },
    {
      label: "Founder",
      value: "founder",
      isSelected: false,
    },
    {
      label: "Health Professional",
      value: "health_professional",
      isSelected: false,
    },
    {
      label: "HR",
      value: "human_resources",
      isSelected: false,
    }, {
      label: "IT",
      value: "information_technology",
      isSelected: false,
    }, {
      label: "Legal",
      value: "legal",
      isSelected: false,
    }, {
      label: "Marketing",
      value: "marketing",
      isSelected: false,
    }, {
      label: "Operations",
      value: "operations",
      isSelected: false,
    }, {
      label: "Owner",
      value: "owner",
      isSelected: false,
    },
    {
      label: "President",
      value: "president",
      isSelected: false,
    },
    {
      label: "Product",
      value: "product",
      isSelected: false,
    }, {
      label: "Public Relations",
      value: "public_relations",
      isSelected: false,
    },
    {
      label: "Real Estate",
      value: "real_estate",
      isSelected: false,
    }, {
      label: "Recruiting",
      value: "recruiting",
      isSelected: false,
    }, {
      label: "Research",
      value: "research",
      isSelected: false,
    },
    {
      label: "Sales",
      value: "sales",
      isSelected: false,
    }],
    seniority: [{
      label: "Executive",
      value: "executive",
      isSelected: false,
    },
    {
      label: "Director",
      value: "director",
      isSelected: false,
    },
    {
      label: "Manager",
      value: "manager",
      isSelected: false,
    }]
  }
}